/**
* 用户邮箱汇总 web api
* @author LCF
* @create 2025-07-21 16:54:01
*/
import request from "@/utils/request"
import service from "@/utils/service"

/**
* 查询用户邮箱汇总列表
* @param param 查询参数
*/
export function list(param) {
return request({
url: service.tcode + "/tcode/subscriptions/list",
method: "post",
data: param
})
}

/**
* 保存用户邮箱汇总数据
* @param data 保存数据
*/
export function save(data) {
  return request({
    url: service.tcode + "/tcode/subscriptions/save",
    method: "post",
    data: data
  })
}

/**
* 根据PK查询一个用户邮箱汇总
* @param pk 主键
*/
export function get(pk) {
  return request({
    url: service.tcode + "/tcode/subscriptions/get/" + pk,
    method: "get"
  })
}
/**
* 批量删除
* @param pks 主键数组
*/
export function deleteBatch(pks) {
  return request({
    url: service.tcode + "/tcode/subscriptions/deleteBatch",
    method: "post",
    data: pks
  })
}
/**
* 根据PK删除 用户邮箱汇总
* @param pk 主键
*/
export function delData(pk) {
  return request({
    url: service.tcode + "/tcode/subscriptions/delete/" + pk,
    method: "get"
  })
}

/**
 * 取得订阅计划
 * @param id_product 产品ID
 */
export function getPlans(id_product) {
  return request({
    url: service.tcode + "/tcode/products/getPlanList/" + id_product,
    method: "get"
  })
}

/**
 * 保存订阅记录
 * @param id_product 产品ID
 */
export function saveSubscription(data) {
  return request({
    url: service.tcode + "/tcode/subscriptions/saveSubscription",
    method: "post",
    data: data
  });
}

/**
 * 根据PK删除 用户邮箱汇总
 * @param id 主键
 */
export function cancelSubscription(data) {
  return request({
    url: service.tcode + "/tcode/subscriptions/cancelSubscription/",
    method: "post",
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/tcode/subscriptions.js